
export const MapPagePattern = /\[##_Map\|([^|]+)\|([^|]*?)\|_##\]/mgi

class MapConverter {
  static toHtml(content) {
    if (MapPagePattern.test(content)) {
      return content.replace(MapPagePattern, (match, id, data) => {
        return `<figure id="${id}" data-ke-type="map" data-maps-data="${data}" data-maps-thumbnail="https://i1.daumcdn.net/icon/editor/img_map_490360.gif"><img src="https://i1.daumcdn.net/icon/editor/img_map_490360.gif"></figure>`;
      })
    }

    return content
  }

  static toTistory(editor, e) {
    const $ = editor.dom.$;
    const mapUrl = editor.settings.maps.map_url || 'http://dmaps.daum.net/map_include/map_editor/v3/iframe.html';
    $('[data-maps-data]', e.node).each((idx, elm) => {
      const $elm = $(elm);
      const id = $elm.attr('id');
      const data = $elm.attr('data-maps-data');
      const mapX = $elm.attr('data-maps-mapx') || '';
      const mapY = $elm.attr('data-maps-mapy') || '';
      const thumbnail = $elm.attr('data-maps-thumbnail');
      const src = `${mapUrl}?id=${id}`;

      const wrap = editor.dom.create('iframe', {
        id: id,
        'data-ke-type': 'map',
        mapdata: data,
        'data-maps-data': data,
        'data-maps-mapx': mapX,
        'data-maps-mapy': mapY,
        'data-maps-thumbnail': thumbnail,
        width: '540px',
        height: '350px',
        frameborder: '0',
        scrolling: 'no',
        src: src,
      });
      elm.outerHTML = wrap.outerHTML;
    });
  }
}

export default MapConverter
